import type { AgentStep, ReportLine } from "../runner/types";
import { aiDetails, waitForAi } from "./aiProgress";

export const aiReadingStep: AgentStep = {
    id: "aiReading",
    async run(ctx, io) {
        const ids = ctx.created.documentIds;
        if (ids.length === 0) return { status: "skipped" };

        const progressId = io.post({
            kind: "progress",
            textId: "app.agent.aiReading.progress",
            progress: { done: 0, total: ids.length },
        });
        const outcome = await waitForAi(ctx, io, ids, progressId);
        const details = aiDetails(outcome);
        const open: ReportLine[] = [];
        if (outcome.notStarted > 0) {
            open.push({ textId: "app.agent.report.aiNotStarted", values: { count: outcome.notStarted } });
        }
        if (outcome.running > 0) open.push({ textId: "app.agent.aiStillRunning", values: { count: outcome.running } });
        if (outcome.stalled) {
            io.post({ kind: "text", textId: "app.agent.aiStillRunning", values: { count: outcome.running } });
        }
        if (outcome.cancelled || outcome.stalled) {
            return { status: "done", open, details, data: { continuesOnServer: true } };
        }

        io.post({
            kind: "done",
            textId: "app.agent.aiReading.done",
            values: { done: outcome.done, failed: outcome.failed },
            details,
        });
        return {
            status: "done",
            summary: [{ textId: "app.agent.report.aiRead", values: { count: outcome.done } }],
            open,
            details,
        };
    },
};
